import logo from '../assets/appLogo/airNext.png'

const configData = {
  logo,
  APP_NAME: 'Airnext',
  country: 'au',
  continent: 'au',
  authorization: null,
  countryCode: '+254-',
  contactNumberLength: 10,
}
export default configData
